import { render } from "./LoadFromFileModal.vue?vue&type=template&id=54f7e426&scoped=true"
import script from "./LoadFromFileModal.vue?vue&type=script&lang=js"
export * from "./LoadFromFileModal.vue?vue&type=script&lang=js"

import "./LoadFromFileModal.vue?vue&type=style&index=0&id=54f7e426&scoped=true&lang=scss"
/* custom blocks */
import block0 from "@/locales/ru/components/users-view/load-from-file-modal.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fusers-view%2FLoadFromFileModal.vue&locale=ru"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/en/components/users-view/load-from-file-modal.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fusers-view%2FLoadFromFileModal.vue&locale=en"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f7e426"]])

export default __exports__